:host{display:flex;justify-content:space-between;width:100%}.label-container{display:flex;flex-direction:column}.caption{color:#232426de;line-height:16px}.toggle-value{color:#23242699;font-size:9px;line-height:12px}
/*# sourceMappingURL=region-of-interest-setting-toggle.component.css.map */
